import { OptionsObject, SnackbarKey, SnackbarMessage } from "notistack";

/**
 * Helper function to create a snackbar with onClick handler that closes only that specific snackbar
 * @param enqueueSnackbar - The enqueueSnackbar function from useSnackbar hook
 * @param closeSnackbar - The closeSnackbar function from useSnackbar hook
 * @param message - The message to display
 * @param options - Additional notistack options
 * @returns The snackbar key
 */
export const enqueueSnackbarWithClose = (
  enqueueSnackbar: (
    message: SnackbarMessage,
    options?: OptionsObject
  ) => SnackbarKey,
  closeSnackbar: (key?: SnackbarKey) => void,
  message: SnackbarMessage,
  options?: OptionsObject
): SnackbarKey => {
  const key = `snackbar-${Date.now()}-${Math.random()}`;

  enqueueSnackbar(message, {
    ...options,
    key,
    SnackbarProps: {
      ...options?.SnackbarProps,
      onClick: () => {
        closeSnackbar(key);
      },
    },
  });

  return key;
};
